import axios from 'axios'
axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')

const state = {
  users: [],
  user: {
    userLoyaltyProgram: {
      totalPoints: 0,
      currentPoints: 0,
      completedTrainings: []
    }
  },
  status: ''
}

const mutations = {
  REQUEST (state) {
    state.status = 'loading'
  },
  SUCCESS (state) {
    state.status = 'success'
  },
  ERROR (state, error) {
    state.status = 'error'
  },
  SET_USER (state, user) {
    state.user = user
  },
  SET_USER_LOYALTY_PROGRAM (state, userLoyaltyProgram) {
    state.user.userLoyaltyProgram = userLoyaltyProgram
  },
  SET_USERS (state, users) {
    state.users = users
  },
  REMOVE_USER (state, id) {
    state.users = state.users.filter(user => user._id !== id)
  },
  UPDATE_USER (state, payload) {
    // payload = { id: 1, fields: [{ prop: <prop>, value: <value> }...] }
    payload.fields.forEach(field => {
      state.user[field.prop] = field.value
    })
  }
}

const actions = {
  removeUser ({ commit }, id) {
    commit('REMOVE_USER', id)
  },
  getUser ({ commit, state }, id = JSON.parse(localStorage.getItem('user'))._id) {
    if (!id) {
      return Promise.reject(new Error('No user id given or found'))
    }
    const routeType = state.user.isAdmin ? 'admin' : 'client'
    return new Promise((resolve, reject) => {
      commit('REQUEST')
      axios.get(`${process.env.VUE_APP_SERVER_HOST}/api/${routeType}/user/${id}`)
        .then(response => {
          commit('SET_USER', response.data.user)
          commit('SUCCESS')
          resolve(response)
        })
        .catch(err => {
          commit('ERROR', err)
          reject(err)
        })
    })
  },
  getUsersById ({ commit }, payload) {
    // payload ex: { userIds: ['1','2','3'] }
    return new Promise((resolve, reject) => {
      commit('REQUEST')
      axios.post(`${process.env.VUE_APP_SERVER_HOST}/api/admin/user/listByIds`, payload)
        .then(response => {
          commit('SET_USERS', response.data.users)
          commit('SUCCESS')
          resolve(response)
        })
        .catch(err => {
          commit('ERROR', err)
          reject(err)
        })
    })
  },
  deleteUserById ({ commit }, id) {
    // payload ex: { userIds: ['1','2','3'] }
    return new Promise((resolve, reject) => {
      commit('REQUEST')
      axios.delete(`${process.env.VUE_APP_SERVER_HOST}/api/admin/user/${id}/delete`)
        .then(response => {
          commit('REMOVE_USER', id)
          commit('SUCCESS')
          resolve(response)
        })
        .catch(err => {
          commit('ERROR', err)
          reject(err)
        })
    })
  },
  updateUserLoyaltyProgram ({ commit }, payload) {
    // { id: '1', userLoyaltyProgram: {approved: true} }
    return new Promise((resolve, reject) => {
      commit('REQUEST')
      axios.post(`${process.env.VUE_APP_SERVER_HOST}/api/admin/userLoyaltyProgram/update`, payload)
        .then(response => {
          commit('SUCCESS')
          resolve(response)
        })
        .catch(err => {
          commit('ERROR', err)
          reject(err)
        })
    })
  },
  clientUpdateUserLoyaltyProgram ({ commit }, payload) {
    // { id: '1', userLoyaltyProgram: <UserLoyaltyProgramObject> }
    return new Promise((resolve, reject) => {
      commit('REQUEST')
      axios.post(`${process.env.VUE_APP_SERVER_HOST}/api/client/userLoyaltyProgram/update`, payload)
        .then(response => {
          commit('SUCCESS')
          resolve(response)
        })
        .catch(err => {
          commit('ERROR', err)
          reject(err)
        })
    })
  },
  async updateUser ({ commit }, payload) {
    // { id: '1', user: {approved: true} }
    commit('REQUEST')
    try {
      const response = await axios.post(`${process.env.VUE_APP_SERVER_HOST}/api/client/user/update`, payload)
      commit('SUCCESS')
      const fields = Object.entries(response.data.result).map((entry) => ({ prop: entry[0], value: entry[1] }))
      // console.log(Object.entries(response.data.result))
      // console.log(fields)
      commit(
        'UPDATE_USER',
        {
          id: payload.id,
          fields
        }
      )
      return response
    } catch (err) {
      commit('ERROR', err)
      throw err
    }
  },
  completeTraining ({ commit, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      commit('REQUEST')
      axios.post(`${process.env.VUE_APP_SERVER_HOST}/api/client/userLoyaltyProgram/completeTraining`, payload)
        .then(response => {
          commit('SUCCESS')
          commit('SET_USER_LOYALTY_PROGRAM', response.data.savedUserLoyaltyProgram)
          resolve(response)
        })
        .catch(err => {
          commit('ERROR', err)
          reject(err)
        })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
